'use client';

import React from 'react';
import { redirect } from 'next/navigation';
import { useSession } from '~/hooks/useSession';

export default function Home() {
  const { status } = useSession();

  // Show loading while checking session
  if (status === 'loading') {
    return (
      <div className="flex-1 justify-center items-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  // Not authenticated - redirect to join flow
  if (status === 'unauthenticated') {
    redirect('/join');
    return null;
  }

  // Authenticated - redirect to app (server will handle onboarding redirects)
  redirect('/app');
  return null;
}
